export const GMAPS_LOADED_SET = 'GMAPS_LOADED_SET';

export const setGmapsLoaded = () => ({
  type: GMAPS_LOADED_SET
});



// WEBPACK FOOTER //
// ./src/redux/actions/google.js